import api from './index'

/**
 * Researcher authentication API service
 */
export default {
  /**
   * Invite a new researcher (Admin)
   */
  async invite(data) {
    const response = await api.post('/api/researchers/invite', data)
    return response.data
  },

  /**
   * Validate invite token
   */
  async validateInvite(token) {
    const response = await api.post('/api/researchers/invite/validate', { token })
    return response.data
  },

  /**
   * Get registration status for an email
   */
  async getRegistrationStatus(email) {
    const response = await api.get('/api/researchers/registration-status', {
      params: { email }
    })
    return response.data
  },


  /**
   * Inititate phone verification (Send OTP)
   */
  async initiatePhoneVerification(email) {
    const response = await api.post('/api/researchers/verify-phone/initiate', {
      email,
      verification_type: 'phone'
    })
    return response.data
  },

  /**
   * Verify phone with code
   */
  async verifyPhone(email, verificationCode, session) {
    const response = await api.post('/api/researchers/verify-phone', {
      email,
      verification_code: verificationCode,
      session
    })
    return response.data
  },

  /**
   * Setup password after verification
   */
  async setupPassword(email, password, confirmPassword) {
    const response = await api.post('/api/researchers/setup-password', {
      email,
      password,
      confirm_password: confirmPassword
    })
    return response.data
  },

  /**
   * Resend verification code
   */
  async resendVerification(email, verificationType, password = null) {
    const response = await api.post('/api/researchers/resend-verification', {
      email,
      verification_type: verificationType,
      password
    })
    return response.data
  },

  /**
   * Login researcher
   */
  async login(email, password, mfaCode = null, session = null) {
    const response = await api.post('/api/researchers/login', {
      email,
      password,
      mfa_code: mfaCode,
      session
    })
    return response.data
  },

  /**
   * Get researcher profile
   */
  async getResearcher(id) {
    const response = await api.get(`/api/researchers/${id}`)
    return response.data
  },

  /**
   * Get researcher's assigned studies
   */
  async getStudies(researcherId) {
    const response = await api.get(`/api/researchers/${researcherId}/studies`)
    return response.data
  },

  /**
   * Get researcher's notifications
   */
  async getNotifications(researcherId) {
    const response = await api.get(`/api/researchers/${researcherId}/notifications`)
    return response.data
  },

  /**
   * Get secure patient summary
   */
  async getPatientSummary(token) {
    const response = await api.get(`/api/patient-summary/${token}`)
    return response.data
  },

  /**
   * Update the shared review status of a participant summary
   */
  async updateReviewStatus(summaryId, reviewStatus) {
    const response = await api.patch(`/api/patient-summary/${summaryId}/review-status`, {
      review_status: reviewStatus
    })
    return response.data
  },

  /**
   * Initiate summary OTP
   */
  async initiateSummaryOtp(token) {
    const response = await api.post(`/api/patient-summary/${token}/otp/initiate`)
    return response.data
  },

  /**
   * Verify summary OTP
   */
  async verifySummaryOtp(token, code) {
    const response = await api.post(`/api/patient-summary/${token}/otp/verify`, {
      token,
      otp_code: code
    })
    return response.data
  },

  /**
   * Admin: Get all researchers
   */
  async getAllResearchers() {
    // Requires admin authentication
    const response = await api.get('/api/admin/researchers')
    return response.data
  },

  /**
   * Admin: Get all studies
   *
   * Accepts optional query params (include_bulk, search, limit, offset) so the
   * researcher study picker can surface bulk ClinicalTrials.gov-synced studies,
   * which are excluded from the default list.
   */
  async getAllStudies(params = {}) {
    const response = await api.get('/api/admin/studies', { params })
    return response.data
  },

  /**
   * Admin: Assign studies to researcher
   */
  async assignStudies(researcherId, studyIds) {
    const response = await api.post(`/api/admin/researchers/${researcherId}/studies`, {
      study_ids: studyIds
    })
    return response.data
  },

  /**
   * Admin: Remove study from researcher
   */
  async removeStudy(researcherId, studyId) {
    const response = await api.delete(`/api/admin/researchers/${researcherId}/studies/${studyId}`)
    return response.data
  }
}
